import { useState } from "react";
import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { NewLeadDialog } from "./NewLeadDialog";

interface Props {
  /** Render icon-only (for the collapsed sidebar). */
  collapsed?: boolean;
  className?: string;
  /**
   * Forwarded to the person/company creation dialogs so the post-create
   * navigation they trigger respects an in-progress dashboard edit. Opening
   * the chooser itself is never gated — only routing away after a record is
   * created.
   */
  confirmNavigate?: () => boolean;
}

/**
 * Primary "New lead" action — opens the person-vs-company chooser. Designed to
 * live in the app sidebar so creating a lead always starts from the type
 * selection, regardless of which section the user is in.
 */
export function NewLeadButton({ collapsed, className, confirmNavigate }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        size="sm"
        onClick={() => setOpen(true)}
        className={cn("w-full", collapsed && "px-0", className)}
        aria-label="New lead"
        title="New lead"
      >
        <Plus className="h-4 w-4" />
        {!collapsed && <span className="ml-2">New lead</span>}
      </Button>
      <NewLeadDialog open={open} onClose={() => setOpen(false)} confirmNavigate={confirmNavigate} />
    </>
  );
}
